import Blockquote from '@tiptap/extension-blockquote'
import Bold from '@tiptap/extension-bold'
import CodeBlock from '@tiptap/extension-code-block'
import Document from '@tiptap/extension-document'
import HardBreak from '@tiptap/extension-hard-break'
import Heading from '@tiptap/extension-heading'
import Highlight from '@tiptap/extension-highlight'
import History from '@tiptap/extension-history'
import Image from '@tiptap/extension-image'
import Italic from '@tiptap/extension-italic'
import Link from '@tiptap/extension-link'
import { BulletList, ListItem, OrderedList } from '@tiptap/extension-list'
import Paragraph from '@tiptap/extension-paragraph'
import Strike from '@tiptap/extension-strike'
import Text from '@tiptap/extension-text'
import TextAlign from '@tiptap/extension-text-align'
import Underline from '@tiptap/extension-underline'
import { Placeholder } from '@tiptap/extensions'

import { Video } from './Video'

export const EXTENSIONS = [
  Document,
  Paragraph,
  Text,
  Bold,
  Italic,
  Underline,
  Strike,
  Heading.configure({ levels: [1, 2, 3] }),
  Highlight,
  BulletList,
  OrderedList,
  ListItem,
  Blockquote,
  CodeBlock,
  HardBreak,
  History,
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  Image.configure({
    allowBase64: true,
    resize: { enabled: true, minWidth: 80, minHeight: 80, alwaysPreserveAspectRatio: true },
  }),
  Link.configure({ openOnClick: false, autolink: true, defaultProtocol: 'https', protocols: ['http', 'https', 'mailto'] }),
  Video,
  Placeholder.configure({ placeholder: 'Start writing the procedure…' }),
]
